import { Component, OnInit, Optional, Inject } from '@angular/core';
import { EditDialogsSetValuesService } from './edit-dialogs-setvalues.service';
import { DialogsAlertComponent } from '../../../../../../../shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import * as _ from 'lodash';

@Component({
  selector: 'app-edit-dialogs-setvalues',
  templateUrl: './edit-dialogs-setvalues.component.html',
  styleUrls: ['./edit-dialogs-setvalues.component.scss']
})
export class EditDialogsSetvaluesComponent implements OnInit {

  /** Subscripción para el guardado de un setvalue */
  $guardar!: Subscription;

  loading: boolean = true;
  defaultLabel: string = "";
  selectedItemsLabel: string = "";
  styleFormat = {width: '100%'};

  constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any,
              public editDialogsSetValuesService: EditDialogsSetValuesService,
              @Optional() private dialogRef: MatDialogRef<EditDialogsSetvaluesComponent>,
              private translateService: TranslateService,
              private dialog: MatDialog) { this.editDialogsSetValuesService.build(); }

  ngOnInit() {
    this.editDialogsSetValuesService.init(this.data).subscribe(result => {
      this.loading = false;
    });
  }

  /**
  * @description
  * Guardar el Setvalue
  */
  guardar() {
    this.loading = true;
    this.$guardar = this.editDialogsSetValuesService.guardar().subscribe(value => {
      console.log(value);
      // -2: El número del setvalue está ausente
      // -1: El número del setvalue ya existe
      // false: Error al guardar
      if (value === -1 || value === false || value === -2) {
        this.errorSetValues('WARNINGS.error_nuevo');
      }
      this.loading = false;
    }, error => {
      console.log(error);
      this.errorSetValues('WARNINGS.error_nuevo');
      this.loading = false;
    });
  }

  /**
  * @description
  * Cierra el dialog setvalues
  */
  aceptar() {
    this.dialogRef.close(true);
  }

  /**
  * @description
  * Deshabilita o habilita el botón aceptar
  */
  deshabilitar(){
    let setvalue = this.editDialogsSetValuesService.setvalues;
    let original = this.editDialogsSetValuesService.originalSetvalues;
    return this.editDialogsSetValuesService.compare(setvalue, original);
  }

  /**
  * @description
  * Abre un cuadro de dialogo para informar de un error
  * @param error Texto a mostrar
  */
  public errorSetValues(error: string) {
    const dialogRef = this.dialog.open(DialogsAlertComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant(error) }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
    });
  }

}
